export default "__VITE_ASSET__w04fGjda__"